import Participants from "./Participants";

export default function ParticipantsTab({ program }) {
    return (
        <div>
            <Participants programId={program.id}/>
        </div>
    )
}
